import React, {useEffect, useState, forwardRef, useImperativeHandle} from 'react'
import { employment } from '../Jsonalldata'
import { CheckBox } from 'sr/helpers/ui-components/company/CheckBox'
import CheckBoxHandle from 'sr/helpers/functions/CheckBoxHandle'
import { FormattedMessage } from 'react-intl'
export const EmploymentTypeChange = forwardRef((props:any , ref) => {

  const [employmentType, setEmploymentType] = useState<any[]>([]);
  const [error, setError] = useState('');

    useEffect(()=> {
      setEmploymentType(props?.data?.employment_type)
    },[props?.data])

    useEffect(()=> {
     const data = {
      employment_type:employmentType
     }
     props.HandleDataProps(data)
    },[employmentType])

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!employmentType || employmentType.length === 0) {
        setError('Please select at least one Employment Type')
        return false
      }
      setError('')
      return true
    }
  }))

  return (
    <>
    <p className='pt-8 text-base '><FormattedMessage id="RECRUITER.POSTJOB.ADDJOBDETAILS.INPUT.EMPTYPE.TITLE" defaultMessage="Employment Type" /></p>
<div className="flex flex-wrap space-x-4">
{employment.map((data, index)=> (
<CheckBox key={index}
value={data.value}
onChange={(e) => CheckBoxHandle(e, employmentType, setEmploymentType)}
checked = {employmentType?.includes(data.value)} />
))}
   </div>
   {error && <div className="text-red-500 text-sm mt-3">{error}</div>}
   </>
     )
})
